import Vue from "vue";
import axios from "axios";

function resolveHttpClient(httpClient) {
    const resolved = httpClient || Vue.prototype?.instance || axios.create();
    if (!resolved || typeof resolved.get !== "function") {
        return axios.create();
    }
    return resolved;
}

function resolveBaseUrl(apiBaseurl, httpClient) {
    const explicitBase = String(apiBaseurl || "").trim();
    if (explicitBase) {
        return explicitBase.replace(/\/$/, "");
    }
    const runtimeBase = String(httpClient?.defaults?.baseURL || "").trim();
    return runtimeBase.replace(/\/$/, "");
}

function buildManagerPath(apiBaseurl, path) {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    const base = String(apiBaseurl || "").trim().replace(/\/$/, "");
    if (!base) {
        return normalizedPath;
    }
    if (/(^|\/)manager$/.test(base)) {
        return `${base}${normalizedPath}`;
    }
    return `${base}/manager${normalizedPath}`;
}

export function getVinPlateRepeatReviewRecords(apiBaseurl = "", params = {}, httpClient) {
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.get(buildManagerPath(resolvedBaseUrl, "/vin-plate-repeat-review-records"), {
        params: {
            reviewStatus: params.reviewStatus || "pending",
            hitDimension: params.hitDimension || "all",
            pageNo: params.pageNo || 1,
            pageSize: params.pageSize || 20,
        },
    });
}

export function getVinPlateRepeatReviewHistory(apiBaseurl = "", reviewRecordId, httpClient) {
    if (!reviewRecordId) {
        throw new Error("reviewRecordId 不能为空");
    }
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.get(
        buildManagerPath(
            resolvedBaseUrl,
            `/vin-plate-repeat-review-records/${reviewRecordId}/history`
        ),
        {
            params: {},
        }
    );
}

export function saveVinPlateRepeatReviewDecision(apiBaseurl = "", reviewRecordId, payload = {}, httpClient) {
    if (!reviewRecordId) {
        throw new Error("reviewRecordId 不能为空");
    }
    if (!payload.decision) {
        throw new Error("payload.decision 必须提供");
    }
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.post(
        buildManagerPath(
            resolvedBaseUrl,
            `/vin-plate-repeat-review-records/${reviewRecordId}/decision`
        ),
        payload
    );
}

export function saveVinPlateRepeatReviewBatchDecision(apiBaseurl = "", payload = {}, httpClient) {
    if (!Array.isArray(payload.reviewRecordIds) || !payload.reviewRecordIds.length) {
        throw new Error("payload.reviewRecordIds 必须提供");
    }
    if (!payload.decision) {
        throw new Error("payload.decision 必须提供");
    }
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.post(
        buildManagerPath(
            resolvedBaseUrl,
            "/vin-plate-repeat-review-records/batch-decision"
        ),
        payload
    );
}
